export const ensureArray = (mayBeArray) => {
    if (Array.isArray(mayBeArray))
        return mayBeArray;
    if (mayBeArray === null || mayBeArray === undefined)
        return [];
    return [mayBeArray];
};
//# sourceMappingURL=ensureArray.js.map